// TODO [DASH-8441]: Remove this hook once consolidated practice is GA — all reads will use GQL.

import { useSelector } from 'react-redux'
import { selectContext } from 'selectors/auth'

/**
 * Returns whether the frontend should read practice data from the
 * consolidated-practice source (GraphQL / REST API) instead of Firestore.
 *
 * Checks practice settings first, then consolidated practice settings,
 * then consolidator featureFlags, defaults to false.
 */
export const useConsolidatedPractice = (): boolean => {
	const context = useSelector(selectContext)
	return (
		context?.practice?.settings?.useConsolidatedPractice ?? // TODO: remove this after GA
		context?.consolidatedPractice?.settings?.useConsolidatedPractice ??
		context?.consolidator?.featureFlags?.useConsolidatedPractice ??
		false
	)
}
